import { reloadWidenVideo } from "./widen-media";

//import { initWidenVideos } from "./widen-media";
var currentButton, currentPopupId, currentPopup, currentProgram, currentProgramVideo, currentMemberStory, currentMemberStoryVideo, homePlanModalID, tabsModalID, contactUsButton, currentVTButton, currentVTVideo, currentVT;
const REVEAL_PROGRAM_MODAL = $('#national-program');
const REVEAL_MEMBER_STORY_MODALS = $('.member-story-modal');
const CONTACT_US_MODAL = $('#contact-us-modal');
const COLLECTIONS_VIRTUAL_TOUR = $('#collections-virtual-tour-modal');

// Open reveal JTM modal form
$(".jtm-main-info").on("click", ".open-jtm-form", function (e) {
    currentButton = $(this);
    currentPopupId = currentButton.attr('data-popup');
    currentPopup = $("#" + currentPopupId);
    $(currentPopup).foundation('open');

    // On JTM modal close, set focus to correct btn
    $(currentPopup).on('closed.zf.reveal', function () {
        var formContainer = $("#" + $(currentPopup).data("form-container"));
        var confirmationContainer = $("#" + $(currentPopup).data("confirmation-container"));
        if (formContainer != undefined) {
            $(formContainer).removeClass('hide');
            
        }
        if (confirmationContainer != undefined) {
            $(confirmationContainer).addClass('hide');
        }
        $(currentPopup).find("form")[0].reset();
        window.initCustomDropdowns();
        $(currentButton).focus();
    });

});

// Open reveal for national programs
$(".national-programming").on("click", ".program-play-video", function (e) {
    currentButton = $(this);
    currentProgramVideo = currentButton.attr('data-program-video');
    currentProgram = currentButton.attr('data-program');
    $(REVEAL_PROGRAM_MODAL).find("source").attr("src", currentProgramVideo);
    $(REVEAL_PROGRAM_MODAL).foundation('open');
    $(REVEAL_PROGRAM_MODAL).addClass(currentProgram);
});

// On modal close, set focus to correct btn - national programs
$(REVEAL_PROGRAM_MODAL).on('closed.zf.reveal', function () {
    $(REVEAL_PROGRAM_MODAL).removeClass(currentProgram);
    $(currentButton).focus();
});


$(".open-home-plan-modal").on("click", function (e) {
    currentVTButton = $(this);
    currentVTVideo = currentVTButton.attr('data-video-src');
    currentVT = currentVTButton.attr('data-home-plan-video');
    $(COLLECTIONS_VIRTUAL_TOUR).find("source").attr("src", currentVTVideo);
    $(COLLECTIONS_VIRTUAL_TOUR).foundation('open');
    $(COLLECTIONS_VIRTUAL_TOUR).addClass(currentVT);
});
// On modal close, set focus to correct btn - national programs
$(COLLECTIONS_VIRTUAL_TOUR).on('closed.zf.reveal', function () {
    $(COLLECTIONS_VIRTUAL_TOUR).removeClass(currentVT);
    $(currentVTButton).focus();
});


// Open reveal for member story videos
$("#owner-stories").on("click", ".member-play-video", function (e) {
    currentButton = $(this);
});

// On modal close, set focus to correct btn -  member story videos
$(REVEAL_MEMBER_STORY_MODALS).on('closed.zf.reveal', function () {
    $(currentButton).focus();
});

// Open reveal for home plan modal videos
$("#home-plans").on("click", ".open-home-plan-modal", function (e) {
    currentButton = $(this);
    homePlanModalID = currentButton.attr('data-home-plan-video');
    $('#' + homePlanModalID).foundation('open');
    $(homePlanModalID).addClass(homePlanModalID);
});

// On modal close, set focus to correct btn -  home plan videos
$(homePlanModalID).on('closed.zf.reveal', function () {
    $(homePlanModalID).removeClass(homePlanModalID);
    $(currentButton).focus();
});

// Open virtual tour modal for QMI listing page
$(".qmi-listing").on("click", ".open-home-plan-modal", function (e) {
    currentButton = $(this);
    homePlanModalID = currentButton.closest('.tabs-panel').attr('id');
    tabsModalID = '#' + homePlanModalID + '-modal';
    $(tabsModalID).foundation('open');
});

// virtual tour modal for QMI listing page -  reset focus
$('.virtual-tour-modal .media-modal-close').on('click', function () {
    $(currentButton).focus();
})

/**
 * Open/CLose Contact Us modal manually to avoid Foundation jumping to the 
 * Contact Us button towards bottom of page on modal close
 */
$(".open-contact-us-modal").on("click", function () {
    contactUsButton = $(this);
    $(CONTACT_US_MODAL).foundation('open');
    $(CONTACT_US_MODAL).addClass('currentForm');
});

// On modal close, set focus to correct btn
$(CONTACT_US_MODAL).on('closed.zf.reveal', function () {
    $(contactUsButton).focus();
});


let Collections_Virtual_TourVideo;

// Trilogy collections virtual tour modal
$("#trilogy-collections").on("click", ".open-colletion-plan-modal", function (e) {
    currentButton = $(this);
    Collections_Virtual_TourVideo = currentButton.attr('data-collection-plan-video');
    $(Collections_Virtual_Tour).find("source").attr("src", Collections_Virtual_TourVideo);
    $(Collections_Virtual_Tour).foundation('open');
});

$('.collections-plan-modal .media-modal-close, .virtual-tour-modal .media-modal-close').on('click', function () {
    $(currentButton).focus();
});

$(document).on('closed.zf.reveal', function() {
    
    $('.reveal-overlay').removeAttr("style");
    $('html').removeClass('is-reveal-open');

    $(document).find("video").each(function (index, elem) {
        var video = elem;

        if ($(video).length > 0) {
            $(video).get(0).pause();
        }
    });
});

$('.media-modal-close').on('click', function(){
    $('.reveal-overlay').removeAttr("style");
    $('html').removeClass('is-reveal-open');
    $(document).find("video").each(function (index, elem) {
        var video = elem;

        if ($(video).length > 0) {
            $(video).get(0).pause();
        }
    });
});

$('.media-modal').on('open.zf.reveal', function(){

    $(document).find(".media-modal iframe").each(function (index, elem) {

        var id = index;
        var iframe = elem;
        var iframeName = "videoiframe" + id;

        $(iframe).attr("id",iframeName);

    });
   
});

// Make sure to handle closing of the modal by pausing any video
// playback elements like widen iframe
$('.media-modal-close').on('click', function(){
    // Get reference to parent reveal element
    let parentRevealModal = $(this).parents(".reveal");
    // Get reference to what was the active slide
    let activeSlide = $(parentRevealModal).find('.slick-active, .swiper-slide-active, .orbit-slide.is-active');
    // Find any iframe within the active slide and reload it effectively pausing it
    activeSlide.find("iframe").each((index, iframe) => {
        reloadWidenVideo(iframe);
    });
});



